'use client';

import classNames from 'classnames';
import { useEffect, useRef, useState } from 'react';
import { ServiceOffering, ServiceOfferingTab } from '@sapientpro/sapientpro-data-models';
import styles from './ServicesSection.module.scss';
import AnimatedTitle from '../AnimatedTitle';
import TextCard from './TextCard';
import MediaCard from './MediaCard';

const ServicesSection = ({ data }: { data: ServiceOffering }) => {
  const [activeTab, setActiveTab] = useState<ServiceOfferingTab>(data.tab[0]);
  const sectionRef = useRef<HTMLDivElement>(null);

  const handleScroll = () => {
    if (sectionRef.current) {
      const sectionRect = sectionRef.current.getBoundingClientRect();

      const offsetDiff = sectionRect.y - 200;
      const bottomOffsetDiff = sectionRect.y + sectionRect.height;

      if (offsetDiff < 0) {
        if (bottomOffsetDiff < 200) {
          sectionRef.current.classList.remove(styles.active);
        } else {
          sectionRef.current.classList.add(styles.active);
        }
      }
    }
  };

  useEffect(() => {
    handleScroll();
    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <section
      className={styles.servicesSection}
      ref={sectionRef}
    >
      <div className={styles.sectionBackground} />
      <div className={styles.descriptionBlock}>
        <h2 className={styles.title}><AnimatedTitle title={data.title} /></h2>
        <p className='bodyLarge'>{data.description}</p>
      </div>
      <div className={styles.tabsContainer}>
        <div className={styles.tabs}>
          {data.tab.map(tab => (
            <button
              key={tab.id}
              type='button'
              onClick={() => setActiveTab(tab)}
              className={classNames(styles.tabItem, 'subtitle', {
                [styles.active]: activeTab.id === tab.id,
              })}
            >
              {tab.name}
            </button>
          ))}
        </div>
        <div className={styles.tabContent}>
          {activeTab.blocks.map(item => {
            const isMediaCard = !!item.media;

            if (isMediaCard) {
              return (
                <MediaCard
                  key={item.id}
                  data={item}
                />
              );
            }
            return (
              <TextCard
                key={item.id}
                data={item}
              />
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
